import { render, staticRenderFns } from "./compGrid.vue?vue&type=template&id=5fc87770&"
import script from "./compGrid.vue?vue&type=script&lang=js&"
export * from "./compGrid.vue?vue&type=script&lang=js&"
import style0 from "./compGrid.vue?vue&type=style&index=0&id=5fc87770&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports